// lib/gtm.js
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID

/** Inject the GTM script dynamically (same as your Angular initialize()) */
export function initGTM() {
  if (typeof window === "undefined" || !GTM_ID) return
  try {
    // --- GTM Loader Script ---
    const GTMLayerScript = document.createElement("script")
    GTMLayerScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `
    // --- Analytics helper (gtag config) ---
    const GTMAnalytics = document.createElement("script")
    GTMAnalytics.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GTM_ID}');
    `
    document.head.appendChild(GTMLayerScript)
    document.head.appendChild(GTMAnalytics)
  } catch (err) {
    console.error("Error adding GTM:", err)
  }
}

/** Trigger custom event (matches Angular's .event()) */
export function gtmEvent(action, eventCategory, eventLabel, value) {
  if (typeof window === "undefined" || typeof window.dataLayer === "undefined") return
  window.dataLayer.push({
    event: "custom_event",
    action,
    ...(eventCategory && { event_category: eventCategory }),
    ...(eventLabel && { event_label: eventLabel }),
    ...(value && { value }),
  })
}

